<template>
  <div class="h-screen flex w-full vx-row no-gutter items-center justify-center bg-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/3 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full lg:w-full">
              <div class="px-8 pt-8">
                <img src="https://cdn.redgirasol.com/green/LOGOS/redgirasol-black-green.png" alt="login">
                <div class="vx-card__title mb-2">
                  <h4>Iniciar sesión</h4>
                  <p>Uso reservado para administradores del sitio</p>
                </div>
                <template v-if="credentials">
                  <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      name="email"
                      placeholder="Correo o alias"
                      class="w-full"
                      v-model="userPayload.email"/>
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                  <vx-input-group class="w-full mt-6 mb-4">
                    <vs-input
                        placeholder="Contraseña"
                        v-validate="'required'"
                        v-on:keyup.enter="submit"
                        data-vv-name="password"
                        autocomplete="current-password"
                        :type="passInputType"
                        v-model.lazy="userPayload.password"/>
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="dark" @click="togglePassInputType()" icon-pack="feather"
                                   :icon="passInputIcon"></vs-button>
                      </div>
                    </template>
                  </vx-input-group>
                  <span class="text-danger text-sm" v-if="messageError !== ''">{{ messageError }}</span>
                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox color="success" v-model="userPayload.emailRemember">Recordar mi usuario</vs-checkbox>
                  </div>
                  <div class="flex flex-wrap justify-between mb-3">
                    <vs-button @click="submit" color="dark"
                               :disabled="userPayload.email == '' || userPayload.password == ''" class="mb-5">Entrar
                    </vs-button>
                  </div>
                </template>
                <template v-else>
                  <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      name="2fa"
                      placeholder="Segundo Factor"
                      class="w-full"
                      v-model="userPayload.twoFactorCode"/>
                  <span class="text-danger text-sm" v-if="messageError2Fa !== ''">{{ messageError2Fa }}</span>
                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox color="success" v-model="userPayload.rememberme">Recordar codigo por 15 días
                    </vs-checkbox>
                  </div>
                  <div class="flex flex-wrap justify-between mb-3">
                    <vs-button @click="set2fa" color="dark" :disabled="loading || userPayload.twoFactorCode == ''"
                               class="mb-5">Entrar
                    </vs-button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState, mapMutations} from "vuex";
const cookieDomain = process.env.VUE_APP_MICROFRONT_DOMAIN;

const iconEye = "icon-eye";
const iconEyeOff = "icon-eye-off";
const textType = "text";

export default {
  data() {
    return {
      passInputPassMode: true,
      userPayload: {
        email: "",
        password: "",
        twoFactorCode: "",
        rememberme: false,
        emailRemember: false
      },
      credentials: true,
      messageError: "",
      messageError2Fa: "",
      redirect_path: "",
      change: null,
      days_left: null,
    }
  },
  mounted() {
    // if (this.isLogged) {
    //     this.redirect();
    // }
    if (localStorage.getItem("emailRemember") !== null) {
      this.userPayload.email = localStorage.getItem("emailRemember");
      //this.$refs.inputPassw.$el.focus();
      this.userPayload.emailRemember = true;
    }
    this.userPayload.device_id = this.$cookies.get("device_id");
  },
  computed: {
    ...mapState("auth", ["errorMessage", "isLogged", "invalid"]),
    ...mapState(["loading"]),
    passInputType() {
      return this.passInputPassMode ? "password" : textType;
    },
    passInputIcon() {
      return this.passInputPassMode ? iconEye : iconEyeOff;
    },
  },
  methods: {
    ...mapActions('auth', ['signIn', 'checkAuth']),
    ...mapMutations("timer", ["registerNextCloseSession"]),
    async set2fa() {
      try {
        await axios.post('/api/auth/mfa/2fa/verify', {
          "code": this.userPayload.twoFactorCode
        })
        this.redirect();
      } catch (err) {
        if (err.response.status) {
          if (err.response.status === 400) {
            this.messageError2Fa = err.response.data.message;
          }
        }
      }
    },
    async checkUser() {
      try {
        let res = await this.checkAuth(this.userPayload);
        if (res === true) {
          this.submit();
        } else {
          this.credentials = false
        }
      } catch (err) {
        //
      }
    },
    async submit() {
      this.$vs.loading()
      try {
        let res = await this.signIn(this.userPayload);
        
        this.$cookies.set(
            "rg_session",
            res.data.access_token,
            '1y',
            null,
            cookieDomain
        );

        await this.$store.commit('menu/renderApp')
        this.$store.commit("auth/setRoleAvailable");

        if (this.userPayload.emailRemember) {
          localStorage.setItem('emailRemember', this.userPayload.email)
        } else {
          localStorage.removeItem('emailRemember');
        }

        if (this.user.change_password === true || this.user.days_left <= 10) {
          sessionStorage.setItem('password_expiration_current_password', this.userPayload.password);
          this.redirect_path = "/password/expiration"
          this.redirect();
        } else {
          this.redirect_path = this.$route.query.redirect ? this.$route.query.redirect : "/";
          this.redirect();
        }
      } catch (err) {
        if (err.message.data.code) {
          this.errorNotif('Error', err.message.data.message)
        }
        if (err.response.status === 400) {
          this.messageError = err.response.data.message;
        }
        this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    },
    async redirect() {
      await this.$router.push(this.redirect_path);
    },
    togglePassInputType() {
      this.passInputPassMode = !this.passInputPassMode;
    },
  }
}
</script>
<style scoped>
.md-card {
  margin-top: 20px;
}

.bg-login {
  background: rgb(203, 255, 0);
  background: radial-gradient(circle, rgba(203, 255, 0, 1) 29%, rgba(40, 222, 24, 1) 65%);
}
</style>
